<template>
  <Financer />
</template>

<script>
import Financer from "../../components/Financer/Financer.vue";
export default {
  components: {
    Financer,
  },
};
</script>